import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, y = 28, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ kicker, title, sub }) {
  return (
    <div className="max-w-2xl">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-black">
          {kicker}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-volt sm:text-3xl lg:text-4xl">
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className="mt-4 text-base text-white sm:text-lg">{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
